
const trashZumen = async (context, actionName, args) => {
  try{
    await context.dispatch("page/startLoading", {}, { root: true }); // TODO loadingStore.loadingProc に書き換える
    const firstArgs = {
      ...args,
      __apiOptions: { noDisplayLoading: true },
    }
    let result = await context.dispatch(`api/${actionName}`, firstArgs, { root: true })
    if(!result){
      return;
    }
    for(;;){
      if(result.done){
        // 完了
        return "OK";
      }
      const loopArgs = {
        continue_token: result.next.continue_token,
        __apiOptions: { noDisplayLoading: true },
      }
      result = await context.dispatch(`api/${actionName}`, loopArgs, { root: true })
      if(!result){
        return;
      }
    }
  }finally{
    await context.dispatch("page/endLoading", {}, { root: true }); // TODO loadingStore.loadingProc に書き換える
  }
} 

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async delete(context, args){
      return await trashZumen(context, 'deleteZumen', args);
    },
    async restore(context, args){
      return await trashZumen(context, 'restoreZumen', args);
    },
  },
}
